module.exports = __webpack_public_path__ + "img/img01.ccd15c36.png";